<script lang="ts">
  import { BADGE_ID } from "../..";

  export let header: string | null = "";
  export let text: string | null = "";
  export let modalTriggerText: string | null = "";
  export let modalCallback: () => void;
</script>

<div id={BADGE_ID} class="pina-badge">
  <div class="pina-badge-header-text">
    {header}
  </div>

  <p class="pina-badge-body-text">
    {text}
  </p>
  <div class="pina-badge-footer">
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div class="pina-badge-footer-left">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="pina-badge-info" on:click={modalCallback}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
        <span>{modalTriggerText}</span>
      </div>
    </div>
    <div class="pina-badge-footer-right">
      <!-- svelte-ignore a11y-missing-attribute -->
      <img
        src="https://static.climate-app.pina.earth/assets/Logo_PINA_EARTH.svg"
        class="pina-badge-logo"
      />
    </div>
  </div>
</div>

<style>
  .pina-badge {
    margin: 1rem 0;
    padding: 1rem;
    border-radius: 0.5rem;
    border: 2px solid #68d668;
    background: #c7f0c7;
  }

  .pina-badge-header-text {
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  .pina-badge-body-text {
    font-size: 0.9rem;
    margin-bottom: 1rem;
  }

  .pina-badge-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.5rem;
  }

  .pina-badge-info {
    vertical-align: middle;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
  }

  .pina-badge-footer-right {
    display: flex;
    gap: 0.5rem;
  }

  .pina-badge-logo {
    width: 3rem;
  }
</style>
